import { render, staticRenderFns } from "./ArrowsDownUp.vue?vue&type=template&id=3456346b&scoped=true"
import script from "./ArrowsDownUp.vue?vue&type=script&lang=js"
export * from "./ArrowsDownUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456346b",
  null
  
)

export default component.exports